export default "__VITE_ASSET__f95d1573__"